export * from './HealthCertificate';
export * from './Document';
export * from './Financial/Receipt';
export * from './Treatment';
export * from './TreatmentEvolution';
export * from './DentalTreatmentEvolution';
export * from './CrcReport';
